import { queries } from "lib/build/dashboards/ktx/queries";
import { Origin } from "lib/build/events";
import {
	Ab0,
	ab0Messages,
	Rh,
	rhMessages
} from "lib/build/forms/ktx/basic-registration-data/clinical-data/bloodGroup";

import { useFormatMessageMap } from "src/common/hooks/useFormatMessageMap";
import { useLastEventByQuery } from "src/features/events";

export function useBloodGroup(): {
	value: string;
	timestamp?: string;
	origin?: Origin;
} {
	const formatMessage = useFormatMessageMap();

	const event1 = useLastEventByQuery<Ab0>(queries.vAb0);
	const event2 = useLastEventByQuery<Rh>(queries.vRh);

	if (event1 === undefined || event2 === undefined) {
		return { value: "-" };
	}

	const s1 = formatMessage(ab0Messages, event1.value);
	const s2 = formatMessage(rhMessages, event2.value);

	return {
		value: `${s1} RH ${s2}`,
		timestamp: event1.timestamp,
		origin: event1.origin
	};
}
